import { useCallback, useState } from 'react'
import { LOAD_STATE } from 'apps/fleet-planner/constants/loads'
import { IStop, ILoad } from 'apps/fleet-planner/types'
import { getNextDriverStatus, IGetNextDriverStatus } from '../utils/driverStatuses'

export enum DRIVER_IN_OUT_FORM_STATE {
  checkedInAt = 'checkedInAt',
  checkedOutAt = 'checkedOutAt',
  statusUpdate = 'statusUpdate',
  dropTrailer = 'dropTrailer',
}

interface IUseDriverInOutForm {
  isFormOpen: boolean
  formState: DRIVER_IN_OUT_FORM_STATE
  currentStop?: IStop
  editFormHandler: (state: DRIVER_IN_OUT_FORM_STATE, stop: IStop) => void
  closeFormHandler: () => void
  getNextStatusData: (load: ILoad) => IGetNextDriverStatus
}

export const useDriverInOutForm = (): IUseDriverInOutForm => {
  const [isFormOpen, setIsFormOpen] = useState<boolean>(false)
  const [formState, setFormState] = useState<DRIVER_IN_OUT_FORM_STATE>(
    DRIVER_IN_OUT_FORM_STATE.statusUpdate
  )
  const [currentStop, setCurrentStop] = useState<IStop>()

  const getNextStatusData = useCallback((load: ILoad) => {
    const { stops = [], status, currentStopSequence = '1' } = load || {}
    return getNextDriverStatus(status as LOAD_STATE, parseInt(currentStopSequence, 10), stops)
  }, [])

  const editFormHandler = useCallback((state: DRIVER_IN_OUT_FORM_STATE, stop: IStop) => {
    setIsFormOpen(true)
    setFormState(state)
    setCurrentStop(stop)
  }, [])

  const closeFormHandler = useCallback(() => {
    setIsFormOpen(false)
    setFormState(DRIVER_IN_OUT_FORM_STATE.statusUpdate)
  }, [])

  return {
    editFormHandler,
    isFormOpen,
    formState,
    currentStop,
    closeFormHandler,
    getNextStatusData,
  }
}
